import React, { Component } from 'react';
import {
    Step,
    Stepper,
    StepLabel,
  } from 'material-ui/Stepper';
import { isMobile } from "react-device-detect";
import { PushForm, AudienceForm, NewMessagePreview, Success } from './';
import { RaisedButton } from 'material-ui';
import firebase from '../../firebase';
import withFirestorePath from '../withFirestorePath';

  class Steppers extends Component {
    constructor(){
          super();
          this.state = {
              pageIndex: 0,
              stepIndex: 0,
              finished: false,
          }
          this.data = {};
          this.steps = ['Select Audience', 'Build Notification', 'Review']
    }

    handleNext = () => {
        const { restaurantPath } = this.props;
        console.log({ SteppersProps: this.props })

        if(this.state.finished == true){
            const notification = {
                title: this.data.title,	
                body: this.data.body,
            };

            let message = {	
                createdAt: new Date(),
                notification,
                androidConfig: {
                    notification: {
                        click_action: 'FLUTTER_NOTIFICATION_CLICK',
                    }
                },
                android: true,
                ios: true,
                type: this.data.type || 'ALL',
                count: 1,

            };

            if(this.data.action && this.data.action.length > 0) {
                message = {
                    ...message,
                    androidConfig: {
                        ...message.androidConfig,
                        notification: {
                            ...message.androidConfig.notification,
                            click_action: this.data.action,
                        }
                    }
                }
            }

            if(this.data.color) {
                message = {
                    ...message,
                    androidConfig: {
                        ...message.androidConfig,
                        notification: {
                            ...message.androidConfig.notification,
                            color: this.data.color,
                        }
                    }
                }
            }


            if(this.data.topic) {
                message = {
                    ...message,
                    topic: this.data.topic,
                }
            }

            if(this.data.url) {
                message = {
                    ...message,
                    data: {
                        ...message.data,
                        url: this.data.url,
                    }
                }
            }

            console.log('Sending message...', { message })
            restaurantPath.collection('messages').add(message);
            
            this.data = {};
        }

        this.setState((prevState) => { 
          return {
            stepIndex: prevState.stepIndex += 1,
            finished: prevState.stepIndex >= 2,
          }
        })
    }

    sendUp = (data) => {
        this.data = {...this.data, ...data};
        console.log(this.data);
    }

    renderView = (index) => {
        const { restaurantPath } = this.props;

        switch (index) {
            case 0:
                return <AudienceForm sendUp={(data) => this.sendUp(data)} />
                
            case 1:
                return <PushForm sendUp={(data) => this.sendUp(data)} />
                
            case 2: 
                return <NewMessagePreview data={this.data}/>
            case 3:
                return <Success redirectLink={`/${restaurantPath.id}/pushes`} />
            default:
                return <div>Something went wrong!</div>
        }
    }

    render(){
        const{
            stepIndex,
            pageIndex,
            finished
        } = this.state;

        return (
            <div>
                <Stepper activeStep={stepIndex} orientation={isMobile ? 'vertical': 'horizontal'}>
                        {this.steps.map((name, idx) => (
                            <Step key={idx}>
                                <StepLabel>{name}</StepLabel>
                            </Step>
                            )
                        )}
                </Stepper>
                {this.renderView(stepIndex)}

                <div style={styles.buttonContainer}>
                    <RaisedButton 
                        label='Back'
                        disabled={stepIndex === 0}
                        onClick={
                        () => this.setState((prevState) => { 
                            return {
                                stepIndex: prevState.stepIndex -= 1,
                                finished: false,
                            }
                        }
                        )}
                    />
                    <RaisedButton 
                        label={finished ? 'SEND PUSH' : 'Next'} 
                        primary={true}
                        onClick={this.handleNext}
                        disabled={stepIndex > 2}
                    />
                </div>
            </div>
        )
    }
  } 

  export default withFirestorePath(Steppers);


  Steppers.defaultProps = {
      stepIndex: 0,
      steps: [],
  }

  const styles = {
    buttonContainer: {
      width: '25%',
      display: 'flex',
      justifyContent: 'space-evenly',
      marginTop: '15px',
      minWidth: '250px',
    }
  }


// WEBPACK FOOTER //
// ./src/components/createEditPush/Steppers.js